// extracted by mini-css-extract-plugin
export default {"centerText":"styles_centerText__CgMbA","TextLink":"styles_TextLink__rSOx0","TextLinkUnderLine":"styles_TextLinkUnderLine__-E-Hr","Small":"styles_Small__m-EMV"};